// Complete mapping of country names to ISO codes
// Based on countries present in output.json
export const countryNameToCode = {
    // North America
    'United States of America': 'US',
    'United States': 'US',
    'USA': 'US',
    'Canada': 'CA',
    'Mexico': 'MX',

    // Western Europe
    'United Kingdom': 'GB',
    'Britain': 'GB',
    'Great Britain': 'GB',
    'France': 'FR',
    'Germany': 'DE',
    'Italy': 'IT',
    'Spain': 'ES',
    'Portugal': 'PT',
    'Netherlands': 'NL',
    'Belgium': 'BE',
    'Switzerland': 'CH',
    'Austria': 'AT',
    'Sweden': 'SE',
    'Norway': 'NO',
    'Denmark': 'DK',
    'Finland': 'FI',
    'Iceland': 'IS',
    'Ireland': 'IE',
    'Luxembourg': 'LU',
    'Liechtenstein': 'LI',
    'Malta': 'MT',
    'Greece': 'GR',
    'Monaco': 'MC',
    'San Marino': 'SM',
    'Andorra': 'AD',
    'Vatican City': 'VA',

    // Eastern Europe and Balkans
    'Poland': 'PL',
    'Hungary': 'HU',
    'Czech Republic': 'CZ',
    'Slovakia': 'SK',
    'Slovenia': 'SI',
    'Croatia': 'HR',
    'Serbia': 'RS',
    'Bulgaria': 'BG',
    'Romania': 'RO',
    'Ukraine': 'UA',
    'Moldova': 'MD',
    'Estonia': 'EE',
    'Latvia': 'LV',
    'Lithuania': 'LT',
    'Albania': 'AL',
    'North Macedonia': 'MK',
    'Macedonia': 'MK',
    'Bosnia and Herzegovina': 'BA',
    'Montenegro': 'ME',
    'Belarus': 'BY',

    // Caucasus and Central Asia
    'Armenia': 'AM',
    'Azerbaijan': 'AZ',
    'Georgia': 'GE',
    'Kazakhstan': 'KZ',
    'Uzbekistan': 'UZ',
    'Turkmenistan': 'TM',
    'Kyrgyzstan': 'KG',
    'Tajikistan': 'TJ',
    'Mongolia': 'MN',

    // East Asia
    'China': 'CN',
    'Hong Kong': 'HK',
    'Macau': 'MO',
    'Taiwan': 'TW',
    'Japan': 'JP',
    'South Korea': 'KR',
    'North Korea': 'KP',

    // South Asia
    'India': 'IN',
    'Pakistan': 'PK',
    'Bangladesh': 'BD',
    'Nepal': 'NP',
    'Bhutan': 'BT',
    'Sri Lanka': 'LK',
    'Maldives': 'MV',

    // Southeast Asia
    'Indonesia': 'ID',
    'Philippines': 'PH',
    'Malaysia': 'MY',
    'Singapore': 'SG',
    'Thailand': 'TH',
    'Vietnam': 'VN',
    'Myanmar': 'MM',
    'Cambodia': 'KH',
    'Laos': 'LA',
    'Brunei': 'BN',
    'East Timor': 'TL',
    'Timor-Leste': 'TL',

    // Middle East
    'Saudi Arabia': 'SA',
    'United Arab Emirates': 'AE',
    'UAE': 'AE',
    'Kuwait': 'KW',
    'Qatar': 'QA',
    'Bahrain': 'BH',
    'Oman': 'OM',
    'Yemen': 'YE',
    'Iraq': 'IQ',
    'Jordan': 'JO',
    'Lebanon': 'LB',
    'Israel': 'IL',
    'Palestine': 'PS',
    'Syria': 'SY',
    'Iran': 'IR',
    'Turkey': 'TR',
    'Cyprus': 'CY',
    'Egypt': 'EG',

    // Africa
    'South Africa': 'ZA',
    'Nigeria': 'NG',
    'Ghana': 'GH',
    'Kenya': 'KE',
    'Tanzania': 'TZ',
    'Uganda': 'UG',
    'Rwanda': 'RW',
    'Burundi': 'BI',
    'Madagascar': 'MG',
    'Mozambique': 'MZ',
    'Zimbabwe': 'ZW',
    'Zambia': 'ZM',
    'Malawi': 'MW',
    'Botswana': 'BW',
    'Lesotho': 'LS',
    'Eswatini': 'SZ',
    'Swaziland': 'SZ',
    'Somalia': 'SO',
    'Sudan': 'SD',
    'South Sudan': 'SS',
    'Ethiopia': 'ET',
    'Eritrea': 'ER',
    'Djibouti': 'DJ',
    'Mauritius': 'MU',
    'Seychelles': 'SC',
    'Comoros': 'KM',
    'Libya': 'LY',
    'Tunisia': 'TN',
    'Algeria': 'DZ',
    'Morocco': 'MA',
    'Western Sahara': 'EH',
    'Senegal': 'SN',
    'Gambia': 'GM',
    'Guinea-Bissau': 'GW',
    'Guinea': 'GN',
    'Sierra Leone': 'SL',
    'Liberia': 'LR',
    'Côte d\'Ivoire': 'CI',
    'Ivory Coast': 'CI',
    'Burkina Faso': 'BF',
    'Niger': 'NE',
    'Mali': 'ML',
    'Chad': 'TD',
    'Cameroon': 'CM',
    'Central African Republic': 'CF',
    'Democratic Republic of the Congo': 'CD',
    'Dem. Rep. Congo': 'CD',
    'Congo': 'CG',
    'Gabon': 'GA',
    'Equatorial Guinea': 'GQ',
    'São Tomé and Príncipe': 'ST',
    'Cape Verde': 'CV',
    'Benin': 'BJ',
    'Togo': 'TG',
    'Réunion': 'RE',
    'Mayotte': 'YT',

    // South America
    'Brazil': 'BR',
    'Argentina': 'AR',
    'Chile': 'CL',
    'Peru': 'PE',
    'Colombia': 'CO',
    'Venezuela': 'VE',
    'Ecuador': 'EC',
    'Uruguay': 'UY',
    'Paraguay': 'PY',
    'Bolivia': 'BO',
    'Guyana': 'GY',
    'Suriname': 'SR',
    'French Guiana': 'GF',

    // Central America and Caribbean
    'Guatemala': 'GT',
    'Honduras': 'HN',
    'El Salvador': 'SV',
    'Nicaragua': 'NI',
    'Costa Rica': 'CR',
    'Panama': 'PA',
    'Cuba': 'CU',
    'Jamaica': 'JM',
    'Haiti': 'HT',
    'Dominican Republic': 'DO',
    'Trinidad and Tobago': 'TT',
    'Barbados': 'BB',
    'Saint Lucia': 'LC',
    'Grenada': 'GD',
    'Saint Vincent and the Grenadines': 'VC',
    'Dominica': 'DM',
    'Bahamas': 'BS',
    'Antigua and Barbuda': 'AG',
    'Saint Kitts and Nevis': 'KN',
    'Belize': 'BZ',

    // Caribbean territories
    'Puerto Rico': 'PR',
    'U.S. Virgin Islands': 'VI',
    'British Virgin Islands': 'VG',
    'Cayman Islands': 'KY',
    'Sint Maarten': 'SX',
    'Saint Martin': 'MF',
    'Saint Barthélemy': 'BL',
    'Curaçao': 'CW',
    'Caribbean Netherlands': 'BQ',
    'Guadeloupe': 'GP',
    'Martinique': 'MQ',
    'Aruba': 'AW',
    'Montserrat': 'MS',
    'Turks and Caicos Islands': 'TC',
    'Bermuda': 'BM',
    'Anguilla': 'AI',

    // Oceania
    'Australia': 'AU',
    'New Zealand': 'NZ',
    'Papua New Guinea': 'PG',
    'Fiji': 'FJ',
    'Solomon Islands': 'SB',
    'Vanuatu': 'VU',
    'Samoa': 'WS',
    'Tonga': 'TO',
    'Kiribati': 'KI',
    'Tuvalu': 'TV',
    'Nauru': 'NR',
    'Marshall Islands': 'MH',
    'Micronesia': 'FM',
    'Palau': 'PW',
    'Cook Islands': 'CK',
    'American Samoa': 'AS',
    'Guam': 'GU',
    'Northern Mariana Islands': 'MP',
    'Pitcairn Islands': 'PN',
    'Tokelau': 'TK',
    'Niue': 'NU',
    'New Caledonia': 'NC',
    'French Polynesia': 'PF',
    'Wallis and Futuna': 'WF',

    // Small Territories and Dependencies
    'Cocos Islands': 'CC',
    'Cocos (Keeling) Islands': 'CC',
    'Christmas Island': 'CX',
    'Norfolk Island': 'NF',
    'U.S. Minor Outlying Islands': 'UM',
    'United States Minor Outlying Islands': 'UM',
    'Falkland Islands': 'FK',


    // European territories
    'Åland Islands': 'AX',
    'Svalbard and Jan Mayen': 'SJ',
    'Guernsey': 'GG',
    'Jersey': 'JE',
    'Isle of Man': 'IM',
    'Faroe Islands': 'FO',
    'Gibraltar': 'GI',

    // Special cases
    'Kosovo': 'XK',

};

// Function to get the correct code with special case for GF
export const getCorrectCountryCode = (countryName, countryId, geoipData) => {
    // Special case: French Guiana appears as "France" in the topological map
    // but is geographically in South America and should map to 'GF'
    if (countryName === 'France' && geoipData) {
        // Check if GF exists in Latin America but not FR in Western Europe
        let hasGF = false;
        let hasFR = false;

        // Handle both array and object formats
        if (geoipData['Latin America']) {
            if (Array.isArray(geoipData['Latin America'])) {
                hasGF = geoipData['Latin America'].includes('GF');
            } else if (typeof geoipData['Latin America'] === 'object') {
                hasGF = 'GF' in geoipData['Latin America'];
            }
        }

        if (geoipData['Western Europe']) {
            if (Array.isArray(geoipData['Western Europe'])) {
                hasFR = geoipData['Western Europe'].includes('FR');
            } else if (typeof geoipData['Western Europe'] === 'object') {
                hasFR = 'FR' in geoipData['Western Europe'];
            }
        }

        if (hasGF && !hasFR) {
            // It's French Guiana, not metropolitan France
            return 'GF';
        }
    }

    // Direct mapping: use name mapping or country ID
    return countryNameToCode[countryName] || countryId;
};// Also create reverse mapping for debugging
export const codeToCountryName = {};
Object.entries(countryNameToCode).forEach(([name, code]) => {
    if (!codeToCountryName[code]) {
        codeToCountryName[code] = name;
    }
});
